// extracted by mini-css-extract-plugin
export default {"latestReports":"FlagDetailsContainer-latestReports-f570338ec56061e221ed6c48bae4e395"};